import React, {useEffect, useState} from "react";
import {forAuthentication, queryCustomerInfo, postAuthoritiesSubmit} from "../../service";
import {GradesVisibleData} from "../types";
import { priceConvert} from "../../units";
import useUserInfo from "../../routers/useUserInfo";
import {useLoading} from "../../components/loading/LoadingProvider";
import {useHistory} from "react-router-dom";
import MakePhoneCall from "../../components/makePhoneCall";
import usePhones from "../../routers/usePhones";
import {useModal} from "../../components/modal";
import TextLoop from "react-text-loop";

function Certification() {
    const [companys,setCompanys] = useState([])
    const [info, setInfo] = useState<GradesVisibleData>()
    const [cover,setCover] = useState<boolean>(false);
    const phones = usePhones()
    const userData = useUserInfo(false)
    const loading = useLoading()
    const modal = useModal()
    const { push } = useHistory()
    let array:any =[];
    useEffect(() => {
        loading.showLoading()
        forAuthentication().then(res => {
            if (res.code === 1) {
                loading.hideLoading()
                setInfo(res.data)
            }else{
                loading.showError(res.msg)
            }
        })
    }, [])
    // useEffect(() => {
    //     queryCustomerInfo().then( res => {
    //         if(res.msg == 'success'){
    //             const companys = res.page
    //             array = companys.map((item:any)=>'恭喜 ['+ item.nickName+ '] 成为BG联盟'+ item.starId)
    //         }
    //         setCompanys(array)
    //     })
    // },[])
    const clickHandle = () => {
        if(userData){
            loading.showLoading()
            postAuthoritiesSubmit({
                userId:userData.id
            }).then(res => {
                if(res.code === 1){
                    loading.hideLoading()
                    window.localStorage.removeItem('wxpay')
                    push(`/order/${res.data.id}/confirm`)
                }else{
                    loading.showError(res.msg)
                }
            })
        }else{
            modal.show({
                content:'此操作需要登录!',
                confirmText:'去登录',
                success:(res) => {
                    if(res.confirm){
                        push('/login')
                    }
                }
            })
        }

    }
    const clickMaterial = () => {
        loading.hideLoading()
        push('/user/personalMaterial')
    }
    const rollInfo = companys && companys.length > 0 ?<TextLoop  children={companys} ></TextLoop>:''

    return <div className="Certification course-detail">
        <div  style={{
            position: 'fixed',
            bottom: '60px',
            width:'100%',
            color:'#FFF',
            fontWeight:'bold',
            paddingLeft:'5px',
            whiteSpace:'pre',
            background:'#00306E',
            fontSize:'15px',
            opacity:0.7,
            borderTopLeftRadius: '.1rem',
            borderBottomLeftRadius: '.1rem',
            borderTopRightRadius: '.1rem',
            borderBottomRightRadius: '.1rem'}}>
            {rollInfo}
        </div>
        {
            info && <div className="text" dangerouslySetInnerHTML={{__html: info.introduction}}/>
        }

        {
            info && <div className="fixed-space" style={{height: '1rem'}}>
                <div className="common-fixed">
                    <div className="common-btn" onClick={() => setCover(true)}>
                        <p className="iconfont">&#xe62e;</p>
                        <p>我要咨询</p>
                    </div>
                    <div  onClick={ clickHandle }  className="common-btn">{priceConvert(info.annualFee)}元/年 立即认证</div>
                    <div style={{borderLeft:'1px solid #eee'}} onClick={ clickMaterial }  className="common-btn">资料下载</div>
                </div>
            </div>
        }
        <MakePhoneCall show={ cover } telephone={ phones[1] } onClose={() => setCover(false)}/>
    </div>
}

export default Certification;
